import React from 'react'
import { Container } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { AuthenticatedUserConsumer, AuthenticatedUserContext } from '../../../AuthenticatedUserContext'
import Alert from '@material-ui/lab/Alert'
import EinvoiceDelegateForm from './EinvoiceDelegateForm'

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  content: {
    background: theme.palette.common.white,
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius
  },
  title: {
    marginTop: 0,
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main
  }
}))

const EinvoiceDelegatesContent = ({ resetSelectedCompany }) => {
  const classes = useStyles()
  const { einvoiceDelegateDisclaimer, getEinvoiceDelegateDisclaimer } = React.useContext(AuthenticatedUserContext)

  React.useEffect(() => {
      resetSelectedCompany()
      if (!einvoiceDelegateDisclaimer) getEinvoiceDelegateDisclaimer()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  return (
    <Container maxWidth="lg" className={classes.container}>
      <div className={classes.content}>
        <h2 className={classes.title}>
          <FormattedMessage id='EinvoiceDelegate.PageTitle'/>
        </h2>
        {!!einvoiceDelegateDisclaimer && (
          <Alert severity="warning" style={{ marginBottom: 16 }}>
            {einvoiceDelegateDisclaimer}
          </Alert>
        )}
        <AuthenticatedUserConsumer>
          {({
              addEinvoiceDelegateFailure,
              addEinvoiceDelegateFailureMessage,
              addEinvoiceDelegateSuccess,
              handleAddEinvoiceDelegate,
              resetAddEinvoiceDelegate,
              einvoiceDelegate,
              einvoiceDelegateLoading,
              getEinvoiceDelegate
            }) => (
            <div>
              {!!addEinvoiceDelegateFailure && !!addEinvoiceDelegateFailureMessage &&
              <Alert severity="error">{addEinvoiceDelegateFailureMessage}</Alert>
              }
              {!!addEinvoiceDelegateSuccess &&
              <Alert severity="success"><FormattedMessage id='EinvoiceDelegate.FormSuccessAlert'/></Alert>
              }
              <EinvoiceDelegateForm
                onSubmit={handleAddEinvoiceDelegate}
                resetStatus={resetAddEinvoiceDelegate}
                delegateData={einvoiceDelegate}
                delegateLoading={einvoiceDelegateLoading}
                getEinvoiceDelegate={getEinvoiceDelegate}
              />
            </div>
          )}
        </AuthenticatedUserConsumer>
      </div>
    </Container>
  )
}

export default EinvoiceDelegatesContent
